import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ta from "time-ago";
import { DeviceGroupSelect, EditableLabel } from "..";
import Icon from "../widgets/Icon/index";
import { Switch, Button } from "signoxe/components/widgets";
import { getProfile } from "signoxe/selectors";
import { ScreenResolutionSelectWidget } from '../widgets/ScreenResolutionSelectWidget/index.js';


import {
  addDeviceUngroupedWrapers,
  addDeviceGroup,
} from "../../actions";

import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";

import SelectSearch from "../widgets/SelectSearch";

import Popup from "signoxe/components/widgets";

import "./styles.scss";

const REBOOT_COMMAND = "reboot";
const RESTART_APP_COMMAND = "restart-app";
const CLEAR_UNUSED_MEDIA_COMMAND = "free-space";

const UngropedDeviceView = ({
  device,
  groupList,
  onChange,
  reportCall,
  screenshotsEnabled,
  deviceReportEnabled,
  offlineEnabled,
  delayDownloadEnabled,
  rebootEnabled,
  RestartAppEnabled,
  ClearUnusedMediaEnabled,
  rebootDevice,
  RestartApp,
  ClearUnusedMedia,
  ShowDeviceInfo,
  addDeviceUngroupedWrapers,
  deviceTags,
  profile,
}) => {
  const offlineOnly = localStorage.getItem('offlineOnly')
  const self_activation = localStorage.getItem('self_activation')
  const DevicesTab = localStorage.getItem('DevicesTab')

  const setUngroup = () => {
    addDeviceUngroupedWrapers({ name: `divice_ungrouped_wraper_for_${device.name}`, deviceId: device.id })
  }

  const handleChangeTag = (option) => {
    onChange({ id: device.id, tags: option })
  }
  

  const handleChangeGroup = (option) => {
    console.log("device group option selected", option )
    onChange({ id: device.id, group: option })
  }
  // DEVICE TAG OPTIONS
  let default_deviceTags = []
  if(device && device.tags){
    default_deviceTags = device.tags
  }
 
  var deviceTags_Options = []
  deviceTags?
    deviceTags.map((option) => {
      deviceTags_Options.push({label:option.name, value:option.id})
    })
  : null
  
  // DEVICE GROUPLIST

  let default_deviceGroupList = []

  if(device && device.group){
    default_deviceGroupList = device.group
  }

  var deviceGroupList_options = []
  groupList?
    groupList.map((option) => {
      deviceGroupList_options.push({label:option.name, value:option.id})
    })
  : null
  

  if(self_activation === 'false'){
    return(
      <tr
        className={classNames("device-view depth-1", {
          disabled: !device.enabled,
          debug: device.debug_mode,
        })}
      >
        <td className="device-name">
          <EditableLabel
            value={device.name}
            onChange={(newVal) => onChange({ ...device, name: newVal })}
          />
          <span className="show-for-small-only">
            {device.name} <strong>pinged</strong> {ta.ago(device.last_ping)}{" "}
          </span>
          {/*ta.ago(device.last_ping)*/}
          <Dropdown>
            <DropdownTrigger>
              <Icon title="User menu" name="ellipsis-v" size="1.2rem" />
            </DropdownTrigger>
            <DropdownContent className="user-menu device-menu card depth-1">
              <li>
                <span className="show-for-small-only">Screenshots:</span>
                <Link to={`devices/${device.id}`}>
                  <Icon title="Screenshots" name="picture-o" />
                </Link>
              </li>
              <li>
                <div
                  className="offline-switch"
                  style={{ margin: "0px" }}
                  onClick={() =>
                    onChange({ id: device.id, device_status: device.device_status=='online'? 'offline' : 'online' })
                  }
                >
                  <span style={{ marginRight: "5px" }}>Offline </span>  
                  <Switch checked={device.device_status != 'online'} size="tiny" />
                </div>
              </li>
              <li onClick={() => rebootDevice(device)}>
                <span>Reboot </span>
                <Icon color="#cc4b37" title="Reboot device" name="power-off" />
              </li>

              <li onClick={() => RestartApp(device)}>
                <span>Restart App</span>
                {/* <Icon color="#cc4b37" title="Reboot device" name="power-off" /> */}
              </li>

              <li onClick={() => ClearUnusedMedia(device)}>
                <span>Clear Unused Media</span>
                {/* <Icon color="#cc4b37" title="Reboot device" name="power-off" /> */}
              </li>
              {
                profile != undefined && profile.profile.package.device_tags?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                      className="show-for-small-only"
                    >
                      Tag
                    </strong>
                    
                    {
                      DevicesTab != 'unassigned devices'?
                      <SelectSearch 
                        placeHolder={default_deviceTags}  
                        options={deviceTags_Options} 
                        style={{width:`8rem`, backgroundColor:'white'}}
                        onSelect={ (values)=>  handleChangeTag(values) }
                        name={'Select tag'}
                        id={'SelectTag'}
                        multiple={true}
                      />
                    : null
                    }
                  </li>
                : null
              }
              {
                profile != undefined && profile.profile.package.device_screen_resolution?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                    >
                      Screen
                    </strong>
                    <ScreenResolutionSelectWidget 
                      device={device}
                      onDeviceChange={onChange}
                    />
                  </li>
                : null
              }
              <li>
                <strong
                  style={{ marginRight: "6px" }}
                  className="show-for-small-only"
                >
                  Group
                </strong>
                {/* <SelectSearch 
                  placeHolder={default_deviceGroupList}  
                  options={deviceGroupList_options} 
                  style={{width:`8rem`, backgroundColor:'white'}}
                  onSelect={ (values)=>  handleChangeGroup(values) }
                  name={'Select group'}
                  id={'SelectGroup'}
                  multiple={false}
                /> */}
                <DeviceGroupSelect
                  groups={groupList}
                  selected={device.group}
                  setUngroup={true}
                  onChange={async (grpId) => {
                    if(grpId != 'Set Ungrouped'){
                      onChange({ id: device.id, group: grpId }) 
                    }else{
                      await onChange({ id: device.id, group: '' }) 
                      await setUngroup()
                    }
                  }}
                />
              </li>
            </DropdownContent>
          </Dropdown>
        </td>
        {/* {screenshotsEnabled && (
          <td className="screen-shots">
            <span className="show-for-small-only">Screenshots:</span>
            <Link to={`devices/${device.id}`}>
              <Icon title="Screenshots" name="picture-o" />
            </Link>
          </td>
        )} */}
        {/* {deviceReportEnabled && (
          <td className="device-reports">
            <span className="show-for-small-only">Download Report:</span>
            <Icon
              onClick={() => {
                //console.log(device);
                reportCall(device.device_id);
              }}
              title="Reports"
              name="download"
            />
          </td>
        )} */}
  
        {/* {rebootEnabled && (
          <td className="device-reboot">
            {
              <button
                className="button reboot-btn"
                style={{ marginBottom: "0px" }}
                onClick={() => rebootDevice(device)}
              >
                Reboot
              </button>
            }
          </td>
        )} */}
  
        {offlineEnabled && (
          <td className="device-offline">
            <div
              style={{ margin: "0px" }}
              onClick={() => onChange({ id: device.id, device_status: device.device_status=='online'? 'offline' : 'online' })}
            >
              <Switch checked={device.device_status != 'online'} size="tiny" />
            </div>
          </td>
        )}
  
        {delayDownloadEnabled &&(
          <td className="last-ping">
            <strong className="show-for-small-only">Device State: </strong>
            {device.device_state}
          </td>)}
  
        <td className="last-ping">
          <strong className="show-for-small-only">Last Ping: </strong>
          {ta.ago(device.last_ping)}
        </td>

        {
          DevicesTab != 'unassigned devices' && profile != undefined && profile.profile.package.device_tags?
            <td className="last-ping hide-for-small-only">
              <SelectSearch 
                placeHolder={default_deviceTags}  
                options={deviceTags_Options} 
                style={{width:`8rem`, backgroundColor:'white'}}
                onSelect={ (values)=>  handleChangeTag(values) }
                name={'Select tag'}
                id={'SelectTag'}
                multiple={true}
              />
            </td>
          : null
        }

        <td className="hide-for-small-only directionRight">
          <Dropdown>
            <DropdownTrigger>
              <Icon title="Device Options" name="sliders" size="1.2rem" />
            </DropdownTrigger>
            <DropdownContent className="user-menu device-menu card depth-1">

            <li onClick={() => ShowDeviceInfo(device)}>
                <span>Get Device Info </span>
                <Icon  title="Device Info" name="info-circle" />
              </li>

              <Link to={`devices/${device.id}`}>
                <li>
                  <span className="">Screenshots </span>
                    <Icon title="Screenshots" name="picture-o" />
                </li>
              </Link>

              <li onClick={() => rebootDevice(device)}>
                <span>Reboot Device </span>
                <Icon color="#cc4b37" title="Reboot device" name="refresh" />
              </li>

              <li onClick={() => RestartApp(device)}>
                <span>Restart App</span>
                <Icon color="#106022" title="Reboot device" name="power-off" />
              </li>

              <li onClick={() => ClearUnusedMedia(device)}>
                <span>Delete Unused Media</span>
                <Icon title="Delete Unused media" name="broom" />
              </li>

              {
                profile != undefined && profile.profile.package.device_screen_resolution?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                    >
                      Screen
                    </strong>
                    <ScreenResolutionSelectWidget 
                      device={device}
                      onDeviceChange={onChange}
                    />
                  </li>
                : null
              }
              
            </DropdownContent>
          </Dropdown>
          <Icon 
          title="Device refresh"
          className={`is-cursor`}
          onClick={(e) => {
            onChange({ ...device });
            e.currentTarget.style.transition = 'transform 3s';
            e.currentTarget.style.transform = 'rotate(360deg)';
            setTimeout(() => {
              e.currentTarget.style.transition = '';
              e.currentTarget.style.transform = '';
            }, 3000);
          }}
          name="refresh" size="1.2rem" />
        </td>
        
        <td className="change-group">
          <DeviceGroupSelect
            groups={groupList}
            selected={device.group}
            setUngroup={true}
            onChange={async (grpId) => {
              if(grpId != 'Set Ungrouped'){
                onChange({ id: device.id, group: grpId })
              }else{
                await onChange({ id: device.id, group: '' }) 
                await setUngroup();
              }
            }}
          />
        </td>
      </tr>
    )
  }
  
  if(self_activation === 'true'){
    if(offlineOnly ==='false'){
      return ( 
      <tr
        className={classNames("device-view depth-1", {
          disabled: !device.enabled,
          debug: device.debug_mode,
        })}
      >
        <td className="device-name">
          <span className="hide-for-small-only">
            <EditableLabel
              value={device.name}
              onChange={(newVal) => onChange({ ...device, name: newVal })}
            />
          </span>
          <span className="show-for-small-only">
            {device.name} <strong>pinged</strong> {ta.ago(device.last_ping)}{" "}
          </span>
          {/*ta.ago(device.last_ping)*/}
          <Dropdown>
            <DropdownTrigger>
              <Icon title="User menu" name="ellipsis-v" size="1.2rem" />
            </DropdownTrigger>
            <DropdownContent className="user-menu device-menu card depth-1">

            <li onClick={() => ShowDeviceInfo(device)}>
                <span>Get Device Info </span>
                <Icon  title="Device Info" name="info-circle" />
              </li>

              <Link to={`devices/${device.id}`}>
                <li>
                  <span className="">Screenshots </span>
                    <Icon title="Screenshots" name="picture-o" />
                </li>
              </Link>

              <li onClick={() => rebootDevice(device)}>
                <span>Reboot Device </span>
                <Icon color="#cc4b37" title="Reboot device" name="refresh" />
              </li>

              <li onClick={() => RestartApp(device)}>
                <span>Restart App</span>
                <Icon color="#106022" title="Reboot device" name="power-off" />
              </li>

              <li onClick={() => ClearUnusedMedia(device)}>
                <span>Delete Unused Media</span>
                <Icon title="Delete Unused media" name="broom" />
              </li>

              {
                profile != undefined && profile.profile.package.device_screen_resolution?
                  <li>
                    <strong
                      style={{ marginRight: "6px" }}
                    >
                      Screen
                    </strong>
                    <ScreenResolutionSelectWidget 
                      device={device}
                      onDeviceChange={onChange}
                    />
                  </li>
                : null
              }
              
            </DropdownContent>
          </Dropdown>
        </td>

        {/* {deviceReportEnabled && (
          <td className="device-reports">
            <span className="show-for-small-only">Download Report:</span>
            <Icon
              onClick={() => {
                //console.log(device);
                reportCall(device.device_id);
              }}
              title="Reports"
              name="download"
            />
          </td>
        )} */}
  
        {offlineEnabled && (
          <td className="device-offline">
            <div
              style={{ margin: "0px" }}
              onClick={() => onChange({ id: device.id, device_status: device.device_status=='online'? 'offline' : 'online' })}
            >
              <Switch checked={device.device_status != 'online'} size="tiny" />
            </div>
          </td>
        )}
  
        {delayDownloadEnabled &&(
          <td className="last-ping">
            <strong className="show-for-small-only">Device State: </strong>
            {device.device_state}
          </td>)}
  
        <td className="last-ping hide-for-small-only">
          <strong className="show-for-small-only">Last Ping: </strong>
          {ta.ago(device.last_ping)}
        </td>

        {
          DevicesTab != 'unassigned devices' && profile != undefined && profile.profile.package.device_tags?
            <td className="last-ping hide-for-small-only">
              <SelectSearch 
                placeHolder={default_deviceTags}  
                options={deviceTags_Options} 
                style={{width:`8rem`, backgroundColor:'white'}}
                onSelect={ (values)=>  handleChangeTag(values) }
                name={'Select tag'}
                id={'SelectTag'}
                multiple={true}
              />
            </td>
          : null
        }

        <td className="hide-for-small-only directionRight">
          <Dropdown>
            <DropdownTrigger>
              <Icon title="Device Options" name="sliders" size="1.2rem" />
            </DropdownTrigger>
            <DropdownContent className="user-menu device-menu card depth-1">
          <li onClick={() => ShowDeviceInfo(device)}>
              <span>Get Device Info </span>
              <Icon  title="Device Info" name="info-circle" />
            </li>

            <Link to={`devices/${device.id}`}>
              <li>
                <span className="">Screenshots </span>
                  <Icon title="Screenshots" name="picture-o" />
              </li>
            </Link>

            <li onClick={() => rebootDevice(device)}>
              <span>Reboot Device </span>
              <Icon color="#cc4b37" title="Reboot device" name="refresh" />
            </li>

            <li onClick={() => RestartApp(device)}>
              <span>Restart App</span>
              <Icon color="#106022" title="Reboot device" name="power-off" />
            </li>

            <li onClick={() => ClearUnusedMedia(device)}>
              <span>Delete Unused Media</span>
              <Icon title="Delete Unused media" name="broom" />
            </li>

            {
              profile != undefined && profile.profile.package.device_screen_resolution?
                <li>
                  <strong
                    style={{ marginRight: "6px" }}
                  >
                    Screen
                  </strong>
                  <ScreenResolutionSelectWidget 
                    device={device}
                    onDeviceChange={onChange}
                  />
                </li>
              : null
            }
            
          </DropdownContent>
          </Dropdown>          
          <Icon 
          title="Device refresh"
          className={`is-cursor`}
          onClick={(e) => {
            onChange({ ...device });
            e.currentTarget.style.transition = 'transform 3s';
            e.currentTarget.style.transform = 'rotate(360deg)';
            setTimeout(() => {
              e.currentTarget.style.transition = '';
              e.currentTarget.style.transform = '';
            }, 3000);
          }}
          name="refresh" size="1.2rem" />
        </td>
        
        <td className="change-group">
          <DeviceGroupSelect
            groups={groupList}
            selected={device.group}
            setUngroup={true}
            onChange={async (grpId) => {
              if(grpId != 'Set Ungrouped'){
                onChange({ id: device.id, group: grpId })
              }else{
                await onChange({ id: device.id, group: '' }) 
                await setUngroup();
              }
            }}
          />
        </td>
      </tr>)
    }else{
      return(
      <tr
        className={classNames("device-view depth-1", {
          disabled: !device.enabled,
          debug: device.debug_mode,
        })}
      >
        <td className="device-name">
          <EditableLabel
            value={device.name}
            onChange={(newVal) => onChange({ ...device, name: newVal })}
          />
          <span className="show-for-small-only">
            {device.name} <strong>pinged</strong> {ta.ago(device.last_ping)}{" "}
          </span>
          {/*ta.ago(device.last_ping)*/}
          <Dropdown>
            <DropdownTrigger>
              <Icon title="User menu" name="ellipsis-v" size="1.2rem" />
            </DropdownTrigger>
            <DropdownContent className="user-menu device-menu card depth-1">
              <li>
                <strong
                  style={{ marginRight: "6px" }}
                  className="show-for-small-only"
                >
                  Group
                </strong>
                
                <DeviceGroupSelect
                  groups={groupList}
                  selected={device.group}
                  setUngroup={true}
                  onChange={async (grpId) => {
                    if(grpId != 'Set Ungrouped'){
                      onChange({ id: device.id, group: grpId }) 
                    }else{
                      await onChange({ id: device.id, group: '' }) 
                      await setUngroup()
                    }
                  }}
                />
              </li>
            </DropdownContent>
          </Dropdown>
        </td>
        
        <td className="change-group">
          <DeviceGroupSelect
            groups={groupList}
            selected={device.group}
            setUngroup={true}
            onChange={async (grpId) => {
              if(grpId != 'Set Ungrouped'){
                onChange({ id: device.id, group: grpId })
              }else{
                await onChange({ id: device.id, group: '' }) 
                await setUngroup();
              }
            }}
          />
        </td>
      </tr>)
    }
  }
}

UngropedDeviceView.propTypes = {
  device: PropTypes.object.isRequired,
  screenshotsEnabled: PropTypes.bool,
  reportCall: PropTypes.func.isRequired,
  deviceReportEnabled: PropTypes.bool,
  groupList: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  deviceTags: PropTypes.object,
};

const mapStateToProps = state => ({
  profile: getProfile(state),
  offlineOnly: state.authState.offlineOnly,
})

export default connect(
  mapStateToProps,
  {
    addDeviceUngroupedWrapers,
    addDeviceGroup,
  }
)(UngropedDeviceView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/DeviceView/index.js